import cx from 'classnames';
import * as React from 'react';

import { CTX_ANNOUNCEMENT_STREAM, StreamContext } from 'chat/components/Stream';
import CurrentUser from 'auth/CurrentUser';
import ErrorReporter from 'app/components/ErrorReporter';
import MessageViewTracker from 'components/MessageViewTracker';
import ChatMessageItem from './ChatMessageItem';
import AnnouncementMessageItem, {
  Props as AnnouncementMessageItemProps,
} from './AnnouncementMessageItem/AnnouncementMessageItem';
import type { SequenceItem } from '../../chunker';

import './MessageItems.scss';

type Props = {
  items: Array<SequenceItem>;
  uuid: string;
};

class MessageItems extends React.Component<Props, {}> {
  isAuthor() {
    const { item } = this.props.items[0];
    if (item.__typename !== 'MessageItem') {
      return <ErrorReporter error="MessageItems - tried to render with non-messages" />;
    }
    return CurrentUser.getUserUuid() === item.sender.uuid;
  }

  getSenderName() {
    const { item } = this.props.items[0];
    if (item.__typename !== 'MessageItem') {
      return <ErrorReporter error="MessageItems - tried to render with non-messages" />;
    }
    return item.sender.name;
  }

  renderContent() {
    const { items } = this.props;

    const messageItems = items.map((item) => {
      const isLast = item === items[items.length - 1];
      const messageItem = item.item;
      const isBroadcast =
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'group' does not exist on type 'GetAnnoun... Remove this comment to see the full error message
        !!messageItem.group || messageItem.type === 'broadcast' || messageItem.type === 'message';
      if (messageItem.__typename !== 'MessageItem') {
        return <ErrorReporter error="MessageItems - tried to render with non-messages" />;
      }
      const isAuthor =
        messageItem.__typename === 'MessageItem' &&
        CurrentUser.getUserUuid() === messageItem.sender.uuid;

      return (
        <StreamContext.Consumer key={item.key}>
          {(streamContext) => {
            const canViewDeliveryInformation =
              (isAuthor && isBroadcast) || streamContext === CTX_ANNOUNCEMENT_STREAM;
            return (
              <MessageViewTracker
                messageUuid={item.item.uuid}
                isBroadcast={isBroadcast}
                chatUuid={this.props.uuid}
                canViewDeliveryInformation={canViewDeliveryInformation}
              >
                {isBroadcast ? (
                  <AnnouncementMessageItem
                    item={item as unknown as AnnouncementMessageItemProps['item']}
                    streamUuid={this.props.uuid}
                    isLastItemOfChunk={isLast}
                    canViewDeliveryInformation={canViewDeliveryInformation}
                  />
                ) : (
                  // @ts-expect-error ts-migrate(2741) FIXME: Property 'lastPushEventReadSequenceNumber' is miss... Remove this comment to see the full error message
                  <ChatMessageItem
                    item={item}
                    streamUuid={this.props.uuid}
                    isLastItemOfChunk={isLast}
                  />
                )}
              </MessageViewTracker>
            );
          }}
        </StreamContext.Consumer>
      );
    });

    if (this.isAuthor()) {
      return <div className="MessageItems-content">{messageItems}</div>;
    }

    return (
      <div className="MessageItems-messageGroup">
        <div className="MessageItems-contentWrap">
          <span className="MessageItems-name">{this.getSenderName()}</span>
          <div className="MessageItems-content">{messageItems}</div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <li
        className={cx('MessageItems', {
          'MessageItems-self': this.isAuthor(),
          'MessageItems-other': !this.isAuthor(),
        })}
      >
        {this.renderContent()}
      </li>
    );
  }
}

export default MessageItems;
